// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__RbjFU","email":"Socials_email__J46kC"};